import React, { memo } from 'react'

import { Container} from './FixedLoader.styles'

interface FixedLoader {
	loading: boolean
}

export default memo(function FixedLoader({ loading }: FixedLoader) {
	return (
		<Container className={loading ? 'shown' : ''}>
			<div className='lds-roller'>
				<div/>
				<div/>
				<div/>
				<div/>
				<div/>
				<div/>
				<div/>
				<div/>
			</div>
		</Container>
	)
})
